import React from "react";
import { Linkedin, Twitter, Youtube, Globe2 } from "lucide-react";
import { useLocale } from "../../i18n/LocaleContext";

export default function Footer() {
  const { t } = useLocale();
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 pt-20 pb-10 border-t border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-md bg-[#0072CE] flex items-center justify-center text-white font-display font-bold">
                i
              </div>
              <div className="leading-tight">
                <div className="text-[11px] tracking-[0.18em] uppercase text-slate-400 font-semibold">
                  Infosys BPM
                </div>
                <div className="font-display font-bold text-white text-lg">
                  OMNISupply<span className="text-[#7DD3FC]">.io</span>
                  <sup className="text-[10px] text-slate-500 ml-0.5">™</sup>
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-sm">
              {t("footer.tagline")}
            </p>
            <div className="mt-6 flex gap-3">
              {[Linkedin, Twitter, Youtube, Globe2].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="h-9 w-9 rounded-md border border-slate-800 hover:border-[#0072CE] hover:text-[#7DD3FC] flex items-center justify-center transition-colors"
                  aria-label="Social link"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white font-semibold text-sm mb-4">{t("footer.platform")}</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#solution" className="hover:text-white">{t("footer.platform.catalog")}</a></li>
              <li><a href="#categories" className="hover:text-white">{t("footer.platform.categories")}</a></li>
              <li><a href="#integrations" className="hover:text-white">{t("footer.platform.integrations")}</a></li>
              <li><a href="#how-it-works" className="hover:text-white">{t("footer.platform.how")}</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold text-sm mb-4">{t("footer.for_leaders")}</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#personas" className="hover:text-white">{t("footer.for_cpos")}</a></li>
              <li><a href="#personas" className="hover:text-white">{t("footer.for_cfos")}</a></li>
              <li><a href="#personas" className="hover:text-white">{t("footer.for_csos")}</a></li>
              <li><a href="#faq" className="hover:text-white">{t("footer.faq")}</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold text-sm mb-4">{t("footer.contact")}</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="mailto:sales.infoshop@infosys.com"
                  className="hover:text-white"
                  data-testid="footer-sales-email"
                >
                  sales.infoshop@infosys.com
                </a>
              </li>
              <li><a href="#lead-form" className="hover:text-white">{t("footer.express")}</a></li>
              <li><a href="https://www.infosysbpm.com" target="_blank" rel="noreferrer" className="hover:text-white">infosysbpm.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} {t("footer.rights")}
          </div>
          <div className="flex gap-5 text-xs text-slate-500">
            <a href="#" className="hover:text-white">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-white">{t("footer.terms")}</a>
            <a href="#" className="hover:text-white">{t("footer.cookies")}</a>
            <a href="#" className="hover:text-white">{t("footer.accessibility")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
